import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../../../components/ConfirmationModal';
import { InviteProcessStatusEnum } from '../enums';


const SENT = InviteProcessStatusEnum['Enviado'];
const SEND_FAILED = InviteProcessStatusEnum['Erro ao enviar'];

// O primeiro envio e o reenvio precisam se distinguir a olho nu: quem ainda nao
// foi convocado aparece em destaque, quem ja foi fica discreto.
const sendActionFor = (statusId) => {
  if (statusId === SENT) {
    return {
      icon: 'sync-alt',
      className: 'dim',
      title: 'Reenviar convocação',
    };
  }
  if (statusId === SEND_FAILED) {
    return {
      icon: 'sync-alt',
      className: 'red-dim',
      title: 'Reenviar convocação — o último envio falhou',
    };
  }
  return {
    icon: 'envelope',
    className: 'green',
    title: 'Enviar convocação',
  };
};


class InviteProcessCard extends React.Component {
  state = {
    confirmResendVisible: false,
  }

  render() {
    const {
      inviteProcess,
      onRemoveUserOfProcess,
      onRemoveAllUsersOfProcess,
      onAddInvitesToProcess,
      onSendProcessInvites,
      onSendInvite,
    } = this.props;
    const { confirmResendVisible } = this.state;

    const totalCount = inviteProcess.invites.length;
    const sentCount = inviteProcess.invites
      .filter(invite => get(invite, 'status.id') === SENT).length;

    return (
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h3 className="m-1">
            {inviteProcess.name}
          </h3>
          <h3>
            {inviteProcess.free_vacancies} vagas
          </h3>
        </div>
        <div className="d-flex justify-content-end mb-2">
          <button
            onClick={() => onRemoveAllUsersOfProcess(inviteProcess.id)}
            className="btn btn-primary"
            disabled={inviteProcess.invites.some(x => x.status.id === InviteProcessStatusEnum['Enviado'])}
            >
            Remover Todos (Não Enviado)
          </button>
        </div>
        {
          inviteProcess.invites.length > 0 ? inviteProcess.invites.map((invite) => {
            const action = sendActionFor(get(invite, 'status.id'));

            return (
              <div
                key={invite.id}
                onClick={() => onRemoveUserOfProcess(invite.id)}
                className="d-flex justify-content-between align-items-center candidate-card"
              >
                <FontAwesomeIcon
                  className="red-dim"
                  size="2x"
                  icon="chevron-left"
                />
                <p className="m-0 text-center candidate-name">{invite.enrollment} ({invite.position || '-'})</p>
                <p className="m-0 candidate-status">{get(invite, 'status.name')}</p>
                {/*
                  Mesma condicao do botao de envio em lote: fora da janela do
                  processo o backend recusa o envio, entao o botao nao aparece.
                */}
                {inviteProcess.can_send_invites && (
                  <button
                    type="button"
                    className="candidate-action"
                    title={action.title}
                    aria-label={action.title}
                    // A linha inteira remove o candidato; o clique no botao nao pode subir.
                    onClick={(e) => {
                      e.stopPropagation();
                      onSendInvite(invite.id);
                    }}
                  >
                    <FontAwesomeIcon className={action.className} icon={action.icon} />
                  </button>
                )}
              </div>
            );
          }) : <p className="m-1 text-center"><i>Nenhum inscrito nessa convocação.</i></p>
        }
        <div className="d-flex h-100 justify-content-end align-items-end m-3">
          {
            inviteProcess.can_set_candidates && (
              <div className="mr-2">
                <button
                  className="btn btn-primary"
                  onClick={() => onAddInvitesToProcess(inviteProcess.id)}
                >
                  adicionar candidatos
                </button>
              </div>
            )
          }
          {
            // Só faz sentido reenviar se alguém já foi convocado. O tom cinza mantém
            // "enviar convocação" como a ação óbvia do card.
            inviteProcess.can_send_invites && sentCount > 0 && (
              <div className="mr-2">
                <button
                  className="btn btn-black"
                  onClick={() => this.setState({ confirmResendVisible: true })}
                >
                  reenviar para todos
                </button>
              </div>
            )
          }
          {
            inviteProcess.can_send_invites && (
              <div>
                <button
                  className="btn btn-primary"
                  onClick={() => onSendProcessInvites(inviteProcess.id)}
                >
                  enviar convocação
                </button>
              </div>
            )
          }
        </div>

        <Modal
          visible={confirmResendVisible}
          title="Reenviar convocação"
          cancelText="Cancelar"
          confirmText="Reenviar"
          height={280}
          onCancel={() => this.setState({ confirmResendVisible: false })}
          onConfirm={() => {
            this.setState({ confirmResendVisible: false });
            onSendProcessInvites(inviteProcess.id, true);
          }}
        >
          <p className="text-center">
            O e-mail de convocação será enviado para os <strong>{totalCount}</strong> candidato(s)
            deste processo, incluindo os <strong>{sentCount}</strong> que já foram convocados.
          </p>
        </Modal>
      </div>
    );
  }
}

InviteProcessCard.propTypes = {
  inviteProcess: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    onboarding: PropTypes.string,
    start_at: PropTypes.string,
    end_at: PropTypes.string,
    invites: PropTypes.arrayOf(PropTypes.shape())
  }),
  onRemoveUserOfProcess: PropTypes.func,
  onAddInvitesToProcess: PropTypes.func,
  onSendProcessInvites: PropTypes.func,
  onSendInvite: PropTypes.func,
};

InviteProcessCard.defaultProps = {
  inviteProcess: {
    invites: [],
  },
  onRemoveUserOfProcess: () => {},
  onAddInvitesToProcess: () => {},
  onSendProcessInvites: () => {},
  onSendInvite: () => {},
};

export default InviteProcessCard;
